// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.8741 3.00781L23.5355 4.84438L20.9999 6.45228V7.99987C20.9999 11.1459 20.4592 13.8298 19.201 15.9541C17.9268 18.1054 15.9693 19.5937 13.3229 20.4198C12.4101 20.7048 10.9 20.982 9.89117 20.9984C6.31921 21.0564 3.29501 19.4502 1.74315 17.6535L0.985352 16.7762L6.40425 13.3398C6.3927 13.3346 6.38117 13.3293 6.36966 13.324C5.48554 12.9171 4.61207 12.3218 3.84186 11.6379C3.07165 10.9541 2.37713 10.1573 1.86837 9.32754C1.3678 8.51116 0.999926 7.58535 0.999926 6.66295V5.78176L22.8741 3.00781ZM13.2321 11.3782L10.4032 13.1722L11.8601 15.3377L10.2008 16.4541L8.71354 14.2436L4.12018 17.1565C5.43722 18.1825 7.4778 19.0373 9.85868 18.9987C10.6452 18.9859 11.9643 18.7487 12.727 18.5107C14.9556 17.815 16.4856 16.6141 17.4801 14.9349C18.4907 13.2288 18.9999 10.9409 18.9999 7.99987V7.72057L14.9211 10.3072L16.3716 12.5787L14.6859 13.6551L13.2321 11.3782Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-pea-filled')
export default class PeaFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'pea-filled',
    }
  }
}
